<template>
  <teleport to="body">
    <transition name="slide-fade-up">
      <div class="periple-dynamic-view" v-if="show">
        <div class="close-view">
          <button @click="close" type="button">
            <i class="icon icon-fullscreen-off" aria-hidden="true"></i>
            {{ EtrTranslate.dynamicView.btnExitFullscreen }}
          </button>
        </div>
        <div id="periple-nav-bar-container" ref="peripleNavBarContainer"></div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import {
  onUnmounted, ref, nextTick, watch,
} from 'vue';
import { EtrTranslate } from '@/services';
import { KEYBOARD_CONST } from '@/const';

export default {
  props: {
    nid: {
      type: String,
      default: '',
    },
    treeData: {
      type: Object,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const peripleNavBarContainer = ref(null);

    const initNav = async () => {
      nextTick(() => {
        const width = peripleNavBarContainer.value.clientWidth;
        const height = window.innerHeight;

        if (window.DynamicView) {
          const barPeriple = new window.DynamicView({
            container: 'periple-nav-bar-container',
            width,
            height,
            draggable: true,
            active: props.nid,
            treeData: props.treeData,
            assetsPath: '/modules/custom/sante_etr/lib/dynamic-view/',
          });

          barPeriple.initPeripleNav();
        }
      });
    };

    const close = () => {
      emit('close');
    };

    function handleKeyup(event) {
      const { keyCode } = event;

      if (props.show && keyCode === KEYBOARD_CONST.escape) {
        close();
      }
    }

    watch(() => props.show, (newShow) => {
      if (newShow) {
        initNav();
        window.addEventListener('keyup', handleKeyup);
      }
    });

    onUnmounted(async () => {
      window.removeEventListener('keyup', handleKeyup);
    });

    return {
      close,
      peripleNavBarContainer,
      EtrTranslate,
    };
  },
};
</script>
